import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlider = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.75 12.5C4.17 12.5 2.847 13.56 2.413 15H0.25V17H2.413C2.847 18.44 4.17 19.5 5.75 19.5C7.33 19.5 8.653 18.44 9.087 17H20.25V15H9.087C8.653 13.56 7.33 12.5 5.75 12.5ZM5.75 17.5C4.923 17.5 4.25 16.827 4.25 16C4.25 15.173 4.923 14.5 5.75 14.5C6.577 14.5 7.25 15.173 7.25 16C7.25 16.827 6.577 17.5 5.75 17.5ZM14.75 6.5C13.17 6.5 11.847 7.56 11.413 9H0.25V11H11.413C11.847 12.44 13.17 13.5 14.75 13.5C16.33 13.5 17.653 12.44 18.087 11H20.25V9H18.087C17.653 7.56 16.33 6.5 14.75 6.5ZM14.75 11.5C13.923 11.5 13.25 10.827 13.25 10C13.25 9.173 13.923 8.5 14.75 8.5C15.577 8.5 16.25 9.173 16.25 10C16.25 10.827 15.577 11.5 14.75 11.5Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.087 3C10.653 1.56 9.33 0.5 7.75 0.5C6.17 0.5 4.847 1.56 4.413 3H0.25V5H4.413C4.847 6.44 6.17 7.5 7.75 7.5C9.33 7.5 10.653 6.44 11.087 5H20.375V3H11.087ZM7.75 5.5C6.923 5.5 6.25 4.827 6.25 4C6.25 3.173 6.923 2.5 7.75 2.5C8.577 2.5 9.25 3.173 9.25 4C9.25 4.827 8.577 5.5 7.75 5.5Z",
		fill: "black"
	})]
});
export default SvgSlider;
